// extracted by mini-css-extract-plugin
export default {"formContainer":"regulation-strategy-editor_formContainer__FP0JV"};